<template>
  <section v-show="show" ref="nav" class="bread-crumb-container">
    <span
      class="level"
      v-for="(level, index) in displayLevels"
      :key="level.id"
      @click.stop="() => goToLevel(level.id)"
      :ref="`level${index}`"
      ><img
        v-if="index > 0"

        src="../../../images/icons/chevron-right-solid.svg"
        class="divider"
      />
      <span
        class="level-text"
        :title="level.name"
        v-if="!shrinkLevels.includes(index)"
        >{{ level.name }}</span
      ><span class="level-text" :title="level.name" v-else>&hellip;</span>
    </span>
  </section>
</template>

<script>
import sum from 'lodash-es/sum'

export default {
  name: 'BreadCrumbs',
  props: {
    routerNavigation: {
      type: Boolean,
      default: true
    },
    levels: Array
  },
  data() {
    return {
      show: true,
      displayLevels: this.levels,
      containerWidth: 0,
      shrinkLevels: []
    }
  },
  watch: {
    levels: function (value) {
      this.displayLevels = value

      if (this.displayLevels.length === 1) return

      const ELLIPSIS_WIDTH = 32

      this.$nextTick(() => {
        this.containerWidth = this.$refs.nav.offsetWidth
        this.shrinkLevels = []

        const archiveElement = this.$refs['level0']
        const archiveNameWidth = archiveElement[0]?.clientWidth || 0

        let levelWidths = []

        for (let i = 1; i < this.displayLevels.length; i++) {
          const element = this.$refs[`level${i}`]
          levelWidths.push(element[0].clientWidth)
        }

        // if total width > container width start shrinking top level elements, starting at level 1
        const backButtonWidth = this.$refs.backButton
          ? this.$refs.backButton.$el.clientWidth
          : 0

        const levelSpace =
          this.containerWidth - backButtonWidth - archiveNameWidth

        // Start shrinking elements if there is not enough space
        if (sum(levelWidths) > levelSpace) {
          let remainingLevelWidths = levelWidths

          // See if we need to shrink more levels
          for (let i = 1; i < levelWidths.length; i++) {
            const currentLevelWidth =
              sum(remainingLevelWidths) +
              this.shrinkLevels.length * ELLIPSIS_WIDTH

            if (currentLevelWidth > levelSpace) {
              this.shrinkLevels.push(i)

              remainingLevelWidths = levelWidths.slice(i)
            } else {
              break
            }
          }
        }
      })
    }
  },
  methods: {
    goToLevel(id) {
      this.$emit('level-changed', id)
    },
    goUp() {
      const higherLevel = this.levels[this.levels.length - 2].id
      this.$emit('level-changed', higherLevel)
    }
  }
}
</script>

<style scoped lang="scss">
.bread-crumb-container {
  //flex-grow: 1;
  display: flex;
  width: 100%;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.level {
  cursor: pointer;
  font-weight: normal;
  font-size: 13px;
  line-height: 18px;
  color: var(--text-color);
  display: inline-flex;
  align-items: center;

  .divider {
    color: #a8a8a8;
    height: 10px;
    margin-left: 4px;
    margin-right: 8px;
  }

  .level-text {
    display: inline-block;
    //max-width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &:last-child {
    font-weight: 500;
    color: var(--sub-color);
  }
}
</style>
